'use client';

import { FC } from 'react';

import Link from 'next/link';

import { pagesPath } from '~/libs/$path';
import { trpc } from '~/libs/client/trpcQuery';
import { useNotification } from '~/providers/Notification';

import AlertIcon from '/public/icons/alert.svg';
import ArrowIcon from '/public/icons/arrow-right.svg';
import Logo from '/public/logo.svg';

import styles from './style.module.css';

export type ErrorTemplateProps = {
  title: string;
  description: string;
  links: {
    label: string;
    url: string;
  }[];
  showLogout?: boolean;
};

export const ErrorTemplate: FC<ErrorTemplateProps> = ({
  title,
  description,
  links,
  showLogout = false,
}) => {
  const { pushNotification } = useNotification();
  const { mutateAsync: logout, isPending: isLoading } =
    trpc.session.delete.useMutation({
      onError: (error) => {
        pushNotification({
          type: 'error',
          message: 'ログアウトに失敗しました',
        });
        console.error(error);
      },
    });

  const handleLogout = async () => {
    if (isLoading) {
      return;
    }
    await logout().catch(() => {});
    window.location.href = pagesPath.login.$url().path;
  };

  return (
    <div className={styles.errorTemplate}>
      <Logo className={styles.logo} />
      <AlertIcon className={styles.icon} width={80} height={80} />
      <h1 className={styles.title}>{title}</h1>
      <p className={styles.message}>{description}</p>
      <ul className={styles.linkList}>
        {links.map((link) => (
          <li className={styles.linkItem} key={link.url}>
            <Link href={link.url} className={styles.link}>
              {link.label}
              <ArrowIcon className={styles.arrow} width={16} height={16} />
            </Link>
          </li>
        ))}
        {showLogout ? (
          <li className={styles.linkItem}>
            <button
              type='button'
              className={styles.logoutButton}
              onClick={handleLogout}
              disabled={isLoading}
            >
              ログアウト
              <ArrowIcon className={styles.arrow} width={16} height={16} />
            </button>
          </li>
        ) : null}
      </ul>
    </div>
  );
};
